import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { DriverAddComponent } from "../driver-add/driver-add.component";
import { DriverViewComponent } from "../driver-view/driver-view.component";
import { TruckOwnerService } from "../truck-owner.service";

@Component({
  selector: "app-drivers",
  templateUrl: "./drivers.component.html",
  styleUrls: ["./drivers.component.css"],
})
export class DriversComponent implements OnInit {
  Matdialogref!: MatDialogRef<DriverViewComponent>;
  matdialogre!: MatDialogRef<DriverAddComponent>;
  token: any;
  driverArray: any;
  document_array: any = [];
  fetch_page: any = 0;
  currentPage: any = 0;
  startPage: any = 1;
  last_page: any = 1;
  driverType: any = -1;
  driverNumber: any = -1;
  loading: boolean = false;
  search_btn: boolean = true;
  clear_btn: boolean = false;
  perPage: any = 10;
  @ViewChild("newItem") newItem!: ElementRef;
  constructor(
    private matDialog: MatDialog,
    private services: TruckOwnerService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");
    this.driverGet(this.driverNumber);
    let triptype = "drivers";
    sessionStorage.setItem("tripType", triptype);
    this.pagination(1);
  }

  getTripsList(selectedDriverType: any) {
    this.driverType = selectedDriverType;
    if (this.driverType == "-1") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.driverGet(this.driverNumber);
      this.document_array = [];
    } else if (this.driverType == "allocated") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.driverGet(this.driverNumber);
      this.document_array = [];
    } else if (this.driverType == "available") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.driverGet(this.driverNumber);
      this.document_array = [];
    } else if (this.driverType == "requested") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.driverGet(this.driverNumber);
      this.document_array = [];
    } else if (this.driverType == "rejected") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.driverGet(this.driverNumber);
      this.document_array = [];
    }
  }
  driverGet(type: any) {
    this.driverNumber = type;
    this.loading = true;
    this.services
      .getTruckownerDriverList(
        this.token,
        this.driverType,
        this.driverNumber,
        this.startPage,
        this.perPage
      )
      .subscribe(
        (response: any) => {
          this.driverArray = response.body.data.data;
          this.document_array.push(response.body.data.meta);
          this.last_page = response.body.data.meta.lastPage;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.driverArray = [];
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
        }
      );
  }

  ViewDrivers(item: any) {
    this.Matdialogref = this.matDialog.open(DriverViewComponent, {
      width: "80vw",
      height: "80vh",
      data: item,
      autoFocus: false,
    });
    this.Matdialogref.afterClosed().subscribe((x) => {
      if (x.status != "close") {
        this.driverGet(this.driverNumber);
      }
    });
  }

  addDriver() {
    this.matdialogre = this.matDialog.open(DriverAddComponent, {
      width: "80vw",
      height: "80vh",
      autoFocus: false,
    });
    this.matdialogre.afterClosed().subscribe((x) => {
      this.driverNumber = -1;
      this.driverGet(this.driverNumber);
    });
  }
  deleteDriver(id: any) {
    this.services.driverDelete(id, this.token).subscribe(
      (response: any) => {
        if (response.status == 200) {
          this.driverGet(this.driverNumber);
        }
      },
      (error) => {
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
        }
      }
    );
  }
  search(value: any) {
    if (value.length < 10) {
      this.snackBar.open("Mobile Number should be of 10 digits only", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (value != "") {
      this.search_btn = false;
      this.clear_btn = true;
      this.fetch_page = 1;
      this.startPage = 1;
      this.driverGet(value);
    }
  }
  validateNumber(event: KeyboardEvent) {
    const input = String.fromCharCode(event.keyCode);
    if (!/[0-9]/.test(input)) {
      event.preventDefault();
    }
  }

  resetSearch() {
    this.newItem.nativeElement.value = "";
    this.search_btn = true;
    this.clear_btn = false;
    this.driverNumber = -1;
    this.fetch_page = 1;
    this.startPage = 1;
    this.driverGet(this.driverNumber);
  }
  pagination(page_status: any) {
    if (page_status == "-1") {
      this.fetch_page = parseInt(this.fetch_page) - 1;
      this.currentPage = this.fetch_page;
      this.startPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.fetch_page) + 1;
      this.fetch_page = this.currentPage;
      this.startPage = this.fetch_page;
    }
    if (page_status == "first") {
      this.fetch_page = this.document_array[0].currentPage;
      this.startPage = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.fetch_page = this.document_array[0].lastPage;
      this.startPage = this.document_array[0].lastPage;
    }
    this.driverGet(this.driverNumber);
  }
}
